import styled, { css } from "styled-components";
import { zIndex } from "../../constants";

const panelWidth = "310px";

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-primary);
  width: 100%;
  top: auto;
  bottom: calc(-100% + 80px);
  transition: all 0.2s ease-out;

  h3 {
    font-family: var(--font-primary);
    font-weight: 700;
    color: var(--color-primary);
    margin: 0 0 10px 0;
  }

  ${(props) =>
    props.isOpen === true &&
    css`
      bottom: 0;
    `}

  &:after {
    content: "";
    position: absolute;
    z-index: ${zIndex.overlay};
    bottom: 0;
    left: 0;
    width: calc(100% - 20px);
    height: 38px;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  @media (min-width: 640px) {

    ${(props) =>
      props.position === "left"
        ? css`
            left: calc(${panelWidth} * -1);
          `
        : css`
            right: calc(${panelWidth} * -1);
          `};

    top: 0;
    bottom: auto;
    width: ${panelWidth};
    border-right: 1px solid var(--color-light-gray);

    ${(props) =>
      props.isOpen === true &&
      css`
        box-shadow: -5px -5px 6px rgba(0, 0, 0, 0.05);
      `}

    ${(props) =>
      props.isOpen === true &&
      props.position === "left" &&
      css`
        left: 0;
      `}
      ${(props) =>
      props.isOpen === true &&
      props.position === "right" &&
      css`
        right: 0;
      `}
  }
`;

export const ToggleButton = styled.button`
  width: 100%;
  height: 80px;
  background: var(--color-primary);
  border: none;
  border-radius: 40px 40px 0 0;
  padding: 32px 50px 10px 50px;
  text-align: left;
  cursor: pointer;

  svg {
    display: none;
    fill: #ffffff;
    width: 15px;
    height: 15px;
    transform: rotate(90deg);
  }

  &:before {
    display: block;
    content: "";
    position: absolute;
    width: 35px;
    border-top: 3px solid #ffffff;
    border-radius: 4px;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (min-width: 640px) {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 40%;
    ${(props) =>
      props.position === "left"
        ? css`
            right: -25px;
          `
        : css`
            left: -25px;
          `}

    width: 25px;
    height: 50px;
    background: var(--color-primary);
    border-radius: 10px 0px 0px 10px;
    box-shadow: 0px 2px 4px #00000029;
    padding: 0;

    svg {
      display: block;
    }

    &:before {
      display: none;
    }

    ${(props) =>
      props.position === "left" &&
      css`
        transform: rotate(180deg);
      `}

    ${(props) =>
      props.isOpen === true &&
      css`
        &:before {
          transform: translateY(-50%) rotate(90deg);
        }
        svg {
          transform: rotate(270deg);
        }
      `}
  }
`;

export const ToggleButtonLabel = styled.div`
  font-size: 20px;
  font-family: var(--font-primary);
  color: #ffffff;

  @media (min-width: 640px) {
    display: none;
  }
`;

export const FilterCount = styled.p`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 4px;
  color: #ffffff;
  margin: 0;
  font-size: 16px;
  font-family: var(--font-primary);
`;

export const ResultsCount = styled.p`
  color: #ffffff;
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: 24px;
  margin: 0 0 20px 0;

  @media (min-width: 640px) {
    margin: 0 0 12px 0;
  }
`;

export const ClearAll = styled.button`
  font-size: 16px;
  font-family: var(--font-primary);
  color: #ffffff;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  display: none;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: none;
  color: #ffffff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  @media (min-width: 640px) {
    display: flex;
  }
`;

export const Header = styled.div`
  position: relative;
  flex: none;
  min-height: 130px;
  padding: 10px 50px 32px 50px;
  background: var(--color-primary);

  @media (min-width: 640px) {
    min-height: 120px;
    padding: 32px 32px 24px 32px;
  }
`;

export const Section = styled.div`
  margin-bottom: 15px;
`;

export const Facets = styled.div`
  position: relative;
  z-index: ${zIndex.overlay};
  padding: 32px 50px 0 50px;
  overflow-y: scroll;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  background: #fafafa;
  height: 100%;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-light-gray);
    border-radius: 5px;
  }

  @media (min-width: 640px) {
    padding: 32px;
  }
`;

export const FacetGroup = styled.fieldset`
  padding: 0;
  margin: 0 0 10px 0;
  border: none;

  legend {
    margin-bottom: 10px;
    padding: 0;
    text-transform: uppercase;
  }

  h3 {
    font-size: 16px;
  }

  label {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 5px;
    font-size: 16px;
  }

  input {
    appearance: none;
    -webkit-appearance: none;
    flex: none;
    margin: 2px 8px 0 0;
    width: 15px;
    height: 15px;
    border: 1px solid var(--color-text-gray);
    border-radius: 3px;
    background: #ffffff;
    position: relative;
    cursor: pointer;

    &:hover {
      border-color: var(--color-primary);
    }

    &:checked {
      background: var(--color-tertiary);
      border-color: var(--color-tertiary);
    }

    &:checked:after {
      content: "";
      position: absolute;
      left: 4px;
      top: 0;
      width: 4px;
      height: 8px;
      border: solid var(--color-primary);
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`;
